import { render, staticRenderFns } from "./TodoEdit.vue?vue&type=template&id=375d57f6&"
import script from "./TodoEdit.vue?vue&type=script&lang=js&"
export * from "./TodoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('375d57f6')) {
      api.createRecord('375d57f6', component.options)
    } else {
      api.reload('375d57f6', component.options)
    }
    module.hot.accept("./TodoEdit.vue?vue&type=template&id=375d57f6&", function () {
      api.rerender('375d57f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/todo/TodoEdit.vue"
export default component.exports